<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      d="M20.1 4H4.9C3.85066 4 3 4.83147 3 5.85714V15.1429C3 16.1685 3.85066 17 4.9 17H20.1C21.1493 17 22 16.1685 22 15.1429V5.85714C22 4.83147 21.1493 4 20.1 4Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 20.9995H16"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 16.9995V20.9995"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
